import React from 'react';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import './video.styl';
//widget
import WidgetComponent from '../widget/WidgetComponent'
//video file
import video_aq_good from '../../media/video1_cut.mp4'; // forest
import video_aq_bad from '../../media/video2_cut.mp4'; // cars
import video_aq_mid from '../../media/video3_cut.mp4'; // city guy

class Video extends React.Component {
  constructor(props) {
    super(props);

    this.videos = [video_aq_good, video_aq_bad, video_aq_mid];
    this.attributions = [
      { text: 'Video by ', link: 'https://www.pexels.com/@ivan-s/', name: 'Ivan S' }, // Good
      { text: 'Video by ', link: 'https://www.pexels.com/@mikebirdy', name: 'Mike Bird' }, // Bad
      { text: 'Video by ', link: 'https://www.pexels.com/@mart-production/', name: 'Mart Production' } // Mid
    ];
    this.state = { 'video': 0, 'aqi': 89 };
    this.scrollToDemo = this.scrollToDemo.bind(this);
  }

  scrollToDemo(e) {
    const targetEl = document.getElementById(e.currentTarget.dataset.targetId);
    window.scroll(0, targetEl.offsetTop - 40);
  }

  componentDidMount() {
    // Get references to all video elements
    this.videoElements = [
      document.getElementById('video-player-0'),
      document.getElementById('video-player-1'),
      document.getElementById('video-player-2')
    ];

    // Deze variabele voorkomt dat we de schakellogica meerdere keren activeren
    this.switching = false;

    // Add event listeners to all videos
    this.videoElements.forEach((video, index) => {
      video.addEventListener('timeupdate', () => {
        // Only listen to the currently active video
        if (index !== this.state.video || !video.duration || this.switching) {
          return;
        }

        const overlap = 1; // Start de volgende video 1s vroeger (cross-fade effect)

        // Controleer of de huidige tijd binnen 1s van het einde is
        if (video.currentTime >= video.duration - overlap) {

          // Zet een vlag om te voorkomen dat we de code opnieuw uitvoeren
          this.switching = true;

          let nextVideoIndex;
          let nextAqi;

          // Bepaal de volgende video
          if (this.state.video === 0) {
            nextVideoIndex = 1;
            nextAqi = 22;
          }
          else if (this.state.video === 1) {
            nextVideoIndex = 2;
            nextAqi = 56;
          }
          else if (this.state.video === 2) {
            nextVideoIndex = 0;
            nextAqi = 89;
          }

          // Get the next video element
          const nextVideo = this.videoElements[nextVideoIndex];

          // Update state and switch videos
          this.setState({ 'video': nextVideoIndex, 'aqi': nextAqi }, () => {
            // Pause current video
            video.pause();

            // Reset next video to start and play it
            nextVideo.currentTime = 0;
            nextVideo.play();

            // Reset the flag for the next loop
            this.switching = false;
          });
        }
      }, false);

      // Add ended event handler for each video
      video.addEventListener('ended', () => {
        video.pause();
      });
    });
  }

  render() {
    return (
      <div className="video-frame">
        <div className="video-overlay"></div>
        <WidgetComponent aqi={this.state.aqi} widgetContainer={'widget-container'}>
        </WidgetComponent>
        <div className="video-frame__button-wrapper">
          <button type="button" className="video-frame__button button" onClick={this.scrollToDemo} data-target-id="demo">
            {this.props.locale === 'en' ? 'Try it yourself' : 'Probeer het zelf'}
          </button>
        </div>
        {this.videos.map((videoSrc, index) => (
          <video
            key={index}
            id={`video-player-${index}`}
            autoPlay={index === 0}
            muted
            playsInline
            style={{ display: this.state.video === index ? 'block' : 'none' }}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support video
          </video>
        ))}
        <div className="video-frame__attribution">
          <p>
            {this.attributions[this.state.video].text}
            <a
              href={this.attributions[this.state.video].link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.attributions[this.state.video].name}
            </a>
          </p>
        </div>
        <div className="video-frame__shadow"></div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(Video);



// WEBPACK FOOTER //
// ./src/components/video/Video.js